export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/data_entry.65a85f1.svg";